var map = {
	"./bedford": 86974,
	"./bedford.js": 86974,
	"./broxbourne": 65548,
	"./broxbourne.js": 65548,
	"./darlington": 30318,
	"./darlington.js": 30318,
	"./demo": 27561,
	"./demo.js": 27561,
	"./hull": 41953,
	"./hull.js": 41953,
	"./kirklees": 37686,
	"./kirklees.js": 37686,
	"./leicester": 61346,
	"./leicester.js": 61346,
	"./northgate": 55320,
	"./northgate.js": 55320,
	"./preston": 53043,
	"./preston.js": 53043,
	"./rushcliffe": 56505,
	"./rushcliffe.js": 56505,
	"./slough": 97018,
	"./slough.js": 97018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54334;